import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { INSTANCE_TYPE_TABS, type InstanceTypeTab } from '@/features/admin/shared/tabs';
import { InstanceTypeDetailPage } from '@/features/admin/instance-types/instance-type-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Détail d'un type d'instance. L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/resources/instance-types/$instanceTypeId')({
  validateSearch: (search: Record<string, unknown>): { tab: InstanceTypeTab } => ({
    tab: INSTANCE_TYPE_TABS.parse(search['tab']),
  }),
  component: InstanceTypeRoute,
});

function InstanceTypeRoute() {
  const { tenant, instanceTypeId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="instanceTypes"
      crumbs={[
        { label: t('nav.items.instanceTypes') },
        { label: <EntityName tenantId={tenant} kind="instanceType" id={instanceTypeId} /> },
      ]}
    >
      <InstanceTypeDetailPage
        tenantId={tenant}
        instanceTypeId={instanceTypeId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
